import React, { PureComponent } from 'react';
import {nl2br} from '../../../utils/utils'
import ButtonItem from './ButtonItem';

class SimpleText extends PureComponent {

    render() {
        return (
            <div className="bubble_box" >
            <div className="bubble_unit">
                <span tabIndex={0} dangerouslySetInnerHTML={{__html:nl2br(this.props.data.text)}}/>
                <ButtonItem data={this.props.data.buttons} fromApp={this.props.fromApp}/>
            </div>
            </div>
        );
    }
};

export default SimpleText;